"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorResponseInterceptorToken = exports.responseInterceptorToken = exports.errorResponseInterceptor = exports.responseInterceptor = void 0;
var read_1 = require("../../commons/read");
function responseInterceptor(response) {
    var firstRequestResponseCallback = function () { return response.data || response; };
    return read_1.handleAutoRefresh().then(firstRequestResponseCallback).catch(firstRequestResponseCallback);
}
exports.responseInterceptor = responseInterceptor;
function errorResponseInterceptor(error) {
    var baseResponse = read_1.handleBaseResponse(error);
    return read_1.handleAutoRefresh()
        .then(function () { return Promise.reject(baseResponse); })
        .catch(function () { return Promise.reject(baseResponse); });
}
exports.errorResponseInterceptor = errorResponseInterceptor;
function responseInterceptorToken(response) {
    return response.data || response;
}
exports.responseInterceptorToken = responseInterceptorToken;
function errorResponseInterceptorToken(error) {
    var baseResponse = read_1.handleBaseResponse(error);
    return Promise.reject(baseResponse);
}
exports.errorResponseInterceptorToken = errorResponseInterceptorToken;
//# sourceMappingURL=responseInterceptor.js.map